import styled from 'styled-components';

export const StyledBingoPopProducts = styled.div`
  width: 100%;
  height: 131px;
  padding: 17px 14px;
  display: flex;

  .products-section {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .main-section {
      width: 32.4%;
    }

    .types-divider {
      border-right-width: 2px;
      border-color: #1b6de317;
      width: 0px;
    }
  }
`;

interface IStyledBingoPopMainProductProps {
  textColor: string;
}

export const StyledSubContainer = styled.div`
  width: 59%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  row-gap: 10px;
  column-gap: 5px;
  align-content: center;
`;

export const StyledBingoPopMainProduct = styled.div<IStyledBingoPopMainProductProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .image-container {
    display: flex;
    justify-content: center;
    overflow: hidden;
    align-items: center;
    height: 48px;
    width: 48px;

    .image {
      max-width: 100px;
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }

  .quantity {
    font-size: 32px;
    font-family: inherit;
    color: ${({ textColor }) => textColor};
    max-width: 100%;
  }
`;

interface IStyledBingoPopSubProductProps {
  textColor: string;
}

export const StyledBingoPopSubProduct = styled.div<IStyledBingoPopSubProductProps>`
  display: flex;
  gap: 2px;
  height: 32px;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  max-width: 31.5%;
  width: 31.5%;

  .image-container {
    display: flex;
    justify-content: center;
    overflow: hidden;
    align-items: center;
    height: 24px;
    width: 24px;

    .image {
      max-width: 24px;
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }

  .quantity {
    font-size: 18px;
    font-family: inherit;
    color: ${({ textColor }) => textColor};
    max-width: calc(100% - 24px);
  }
`;
